<template>
	<div class="inline-box">
		<span @click="drawer=true">
			<svg-icon icon-class="cj-icon-reminder" style="cursor: pointer;" />
			<div class="messageCount" style="cursor: pointer;" v-if="messageList.length>0">{{messageList.length}}</div>
		</span>
		<el-drawer ref="drawer" :modal-append-to-body="false" :withHeader="false" :size=400 :visible.sync="drawer" direction="rtl">
			<div style="line-height: initial">
				<Information v-if="drawer == true" @close="drawer=false" />
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import Information from '@/components/Information';

export default {
	name: 'InformationTip',
	components: {
		Information
	},
	data() {
		return {
			drawer: false
		}
	},
	computed: {
		...mapState({
			messageList: state => state.notify.messageList
		}),
	},
	mounted() {
		this.getMessageCenterList();
	},
	methods: {
		getMessageCenterList() {
			this.$api.mssageCenterList()
				.then(res => {
					if (res && res.errcode == 0) {
						this.$store.dispatch("notify/setMessageList", res.data);
					}
				})
				.catch(err => {
					this.$store.dispatch("notify/setMessageList", []);
				})
		},
	}
}
</script>
<style lang="scss" scoped>
.inline-box {
	position: relative;
	display: inline-block;
	padding: 0px 10px 0 5px;
	font-size: 20px;
	color: #5a5e66;
	vertical-align: text-bottom;
	box-sizing: border-box;
}

.messageCount {
	border-radius: 8px;
	padding: 0 1px;
	position: absolute;
	top: 30px;
	right: 5px;
	transform: translate(0, -100%);
	font-size: 12px;
	background: red;
	color: white;
	width: max-content;
	height: max-content;
	min-width: 16px;
	min-height: 16px;
	line-height: 16px;
	text-align: center;
	user-select: none;
}
</style>